export const notAvailable = [
  'toluene',
  'dichloroethane',
  'tetrahydrofuran',
  'chloroform',
  'acetaldehyde',
  'benzene',
  'dichloromethane',
  'tetrahydrofurane',
  'thf',
  'edc',
  'dcm',
];

export function anyAggregate(vals) {
  let any = true;

  vals.forEach(value => {
    if (!value || value === 'NO' || value === 0 || value.length === 0) {
      any = false;
    }
  });

  return any;
}

export function solventsAggregate(vals) {
  let any = true;

  vals.forEach(value => {
    if (!value || value === 'NO' || value === 0 || value.length === 0) {
      any = false;
    } else if (value.length) {
      any = value.reduce((acc, v) => {
        let val = v.toLowerCase().split('-');
        val = val[val.length - 1];
        if (!notAvailable.includes(val)) return true;
        return acc;
      }, false);
    }
  });

  return any;
}

export function medianAggregate(vals) {
  const values = vals.filter(v => v !== null).map(v => (v === -1 ? 100 : v));
  if (!vals || vals.length === 0 || values[0] === null) return 0;
  const mid = Math.floor(values.length / 2);
  const nums = [...values].sort((a, b) => a - b);
  return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
}

export function priceMedianToRange(vals) {
  const median = medianAggregate(vals);
  if (median === 0) return 0;
  if (median < 600) return 1;
  if (median < 1000) return 2;
  if (median < 1400) return 3;
  if (median < 1800) return 4;
  return 5;
}

export function rangeAggregate(vals) {
  let min = vals[0] || 0;
  let max = vals[0] || 0;
  if (typeof vals[0] === 'string' && vals[0].indexOf('-') > 0) {
    const split = vals[0].split('-');
    min = parseInt(split[0], 0);
    max = parseInt(split[1], 0);
  } else if (typeof vals[0] === 'string') {
    min = parseInt(vals[0], 0);
    max = min;
  }

  vals.forEach(value => {
    if (typeof value === 'string' && value.indexOf('-') > 0) {
      const split = value.split('-');
      min = Math.min(min, parseInt(split[0], 0));
      max = Math.max(max, parseInt(split[1], 0));
    } else {
      if (typeof value === 'string') {
        value = parseInt(value, 0);
      }
      min = Math.min(min, value);
      max = Math.max(max, value);
    }
  });

  if (min === max) return min;
  return typeof min === 'number' && typeof max === 'number'
    ? { min, max }
    : null;
}
